import { ApplicationConfig, PLATFORM_ID } from '@angular/core';

import { provideRouter, withComponentInputBinding } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideStore } from '@ngrx/store';
import {
  QueryClient,
  provideAngularQuery,
} from '@tanstack/angular-query-experimental';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { provideLottieOptions } from 'ngx-lottie';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import {
  BrowserModule,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { FormsModule } from '@angular/forms';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { isDevMode } from '@angular/core';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { reducers, metaReducers } from './core/store';
import { APP_ROUTES } from './routes/app-router';
import { isPlatformBrowser } from '@angular/common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    importProvidersFrom(BrowserModule),
    provideToastr(),
    provideStore(reducers, { metaReducers }),
    provideAngularQuery(
      new QueryClient()
      //   withDevtools(() => ({
      //     loadDevtools: isPlatformBrowser(PLATFORM_ID) && isDevMode(),
      //   }))
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor, errorInterceptor])
    ),
    provideAnimationsAsync(),
    provideAngularSvgIcon(),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAnimations(),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    // importProvidersFrom(
    //   Angular4PaystackModule.forRoot(environment.paystackKey)
    // ),
    provideClientHydration(withEventReplay()),
  ],
};
